import { Menu as MenuIcon } from '@mui/icons-material'
import { AppBar, Box, IconButton, Toolbar, createTheme } from '@mui/material'
import Logo from 'common/components/Logo'
import { selectPortal } from 'features/portal/portalSlice'
import { selectUsuario } from 'features/users/stores/userSlice'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link as LinkNav } from 'react-router-dom'
import { default as ThemeManager, default as ThemesManager } from 'theming/ThemeManager'
import HeaderActions from './HeaderActions'

const Header = ({ handleDrawerToggle }) => {
  const portal = useSelector(selectPortal)
  const usuario = useSelector(selectUsuario)

  const themeController = new ThemesManager()

  const [theme, setTheme] = useState(
    createTheme({
      palette: themeController.activePallete(),
    }),
  )

  const themeManager = new ThemeManager()

  const logoOutside = themeManager.options.loginLogoOutside ?? false
  const apply = themeManager.options.apply ?? false

  useEffect(() => {
    setTheme(theme)
  }, [])

  if (!usuario) return <></>

  return (
    <AppBar
      className="main-header"
      sx={{
        boxShadow: 'none',
        px: 0,
        width: '100%',
        zIndex: 98,
        position: 'sticky',
        top: 0,
        backgroundColor: 'transparent',
      }}
    >
      <Toolbar
        className="main-header-toolbar"
        sx={{
          height: {
            xs: '50px',
            md: '50px',
          },
          px: { xs: 0, sm: 1 },
          maxHeight: '80px',
          minHeight: '70px !important',
          backgroundColor: {
            xs: 'primary.main',
            md: 'background.default',
          },

          paddingTop: {
            xs: '0px',
            md: 3,
          },
        }}
      >
        <IconButton
          className="main-header-menu-button"
          sx={{
            display: {
              xs: 'flex',
              md: themeController.activeTheme.options.fullHideMenu ? 'flex' : 'none',
            },
            color: { xs: 'background.alternativeContrastText', md: 'text.primary' },
          }}
          aria-label="menu"
          size="large"
          onClick={handleDrawerToggle}
        >
          <MenuIcon color="background.alternativeContrastText" fontSize="inherit" />
        </IconButton>
        {apply ? (
          <></>
        ) : (
          <>
            <HeaderActions />
            <Box sx={{ flexGrow: 1 }}></Box>
          </>
        )}
        <Box
          className="main-header-logo"
          sx={{
            display: { xs: 'none', md: 'flex' },
            // padding: 2,
            // width: '100%',
            // maxWidth: '20%',
            height: '100%',
          }}
        >
          <LinkNav
            to={portal?.portal?.parametros_seo?.url_logo ?? '/'}
            style={{ width: 'auto', height: '100%' }}
            target={portal?.portal?.parametros_seo?.url_logo ? '_blank' : '_self'}
          >
            <Logo logoType="Header" sx={{ height: '100%', width: 'auto' }} />
          </LinkNav>
        </Box>
        {apply ? (
          <>
            <Box sx={{ flexGrow: 1 }}></Box>
            <HeaderActions />
          </>
        ) : (
          <></>
        )}
      </Toolbar>
    </AppBar>
  )
}
export default Header
